/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // If url contains .com/products/ make sure page is scrolled to top

    if (window.location.href.indexOf('.com/products/') > -1) {
      window.scrollTo(0, 0);
    }
  });

  let productGridSwatches = document.querySelectorAll('.product-grid-item .swatch__button');

  const productPageSwatches = document.querySelectorAll('.product-page .swatch__button');
  const productPageSizeSelector = document.querySelectorAll('.product-page .selector-wrapper[data-select-label="Size"] .radio__inputs .radio__button');
  const productPageMetafieldBadge = document.querySelector('.product-page .metafield--badge.anchor');

  // When a grid swatch is clicked, update the product's price and image links
  let retryCount = 0;
  const maxRetries = 10;

  // Retry handleGridSwatches every 500ms up to 10 times
  if (!productGridSwatches || productGridSwatches.length === 0) {
    const retryInterval = setInterval(() => {
      if (retryCount >= maxRetries) {
        clearInterval(retryInterval);
        return;
      }

      productGridSwatches = document.querySelectorAll('.product-grid-item .swatch__button');

      if (productGridSwatches && productGridSwatches.length > 0) {
        clearInterval(retryInterval);
        handleGridSwatchClick();
      }

      retryCount++;
    }, 500);
  }

  else {
    handleGridSwatchClick();
  }

  function handleGridSwatchClick() {
    const collectionPageProducts = document.querySelector('.collection .collection__products, .collection-tabs .related__products');

    if (!collectionPageProducts || collectionPageProducts.length === 0) {
      return;
    }

    const observer = new MutationObserver(function() {
      const productGridSwatches = document.querySelectorAll('.product-grid-item .swatch__button');

      if (!productGridSwatches) {
        return;
      }

      productGridSwatches.forEach(swatch => swatch.addEventListener('click', updatePriceAndImageLinks));
    });

    observer.observe(collectionPageProducts, {
      childList: true,
      subtree: true
    });

    productGridSwatches.forEach(swatch => swatch.addEventListener('click', updatePriceAndImageLinks));

    /*
    productGridSwatches.forEach(swatch => {
      swatch.addEventListener('click', updatePriceAndImageLinks);

      // Click swatch's label if the swatch is the first in the list
      const label = swatch.querySelector('.swatch__label');

      if (label && swatch === swatch.parentNode.firstElementChild) {
        // First see if the swatch has a sibling
        const swatchSiblingLabel = swatch.nextElementSibling?.querySelector('.swatch__label');

        // If the swatch has a sibling, click the sibling's label then click the swatch's label
        if (swatchSiblingLabel) {
          triggerElementClick(swatchSiblingLabel);
          triggerElementClick(label);
        }
      }

    });
    */

    function updatePriceAndImageLinks(event) {
      const swatch = event.target.closest('radio-swatch');

      if (!swatch) {
        return;
      }

      const label = swatch.querySelector('.swatch__label');

      const productContainer = swatch.closest('.product-grid-item');
      const productInfoLink = productContainer.querySelector('.product__grid__info a');
      const productImageLink = productContainer.querySelectorAll('.product-grid-item__container a');
      const priceContainer = productContainer.querySelector('.product__grid__price .price');
      const compareAtPriceContainer = productContainer.querySelector('.product__grid__price .compare-at');

      const variantId = label.dataset.gridItemVariant;
      const variantPrice = label.dataset.variantPrice;
      const variantCompareAtPrice = label.dataset.variantCompareAtPrice;

      if (compareAtPriceContainer) {
        if (Number(variantCompareAtPrice) > Number(variantPrice)) {
          compareAtPriceContainer.innerHTML = '$' + (variantCompareAtPrice * 0.01).toFixed(2);
          priceContainer.innerHTML = '$' + (variantPrice * 0.01).toFixed(2);
          priceContainer.classList.add('on-sale');
        }

        else {
          compareAtPriceContainer.innerHTML = '';
          priceContainer.innerHTML = '$' + (variantPrice * 0.01).toFixed(2);
          priceContainer.classList.remove('on-sale');
        }
      }

      const url = new URL(productInfoLink.href);
      url.searchParams.set('variant', variantId);

      productInfoLink.href = url.pathname + '?' + url.searchParams;

      productImageLink.forEach(link => {
        link.href = url.pathname + '?' + url.searchParams;
      });
    }

    function triggerElementClick(element) {
      element.click();
      element.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
    }
  }

  // When a product page swatch is clicked, update the product's model information
  if (productPageSwatches && productPageSizeSelector && productPageMetafieldBadge) {
    // Reset the model information when size is clicked (via a programmatic click)
    productPageSizeSelector.forEach(size => {
      size.addEventListener('click', () => {
        Array.from(productPageSwatches).some(swatch => {
          const input = swatch.querySelector('input');

          if (input.checked) {
            swatch.click();
            return true;
          }
        })
      });
    })

    // Find the model information for the selected swatch when clicked
    productPageSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const dataset = swatch.dataset;
        const anchorKey = swatch.dataset.anchorKey.replace(" ", "");
        const pinKey = "modelInfo";

        let currentSize = null;
        let modelInfo = null;

        // Find the current size
        productPageSizeSelector.forEach(size => {
          const input = size.querySelector('input');

          if (input.checked) {
            currentSize = input.value.toLowerCase();
          }
        });

        // Find the model information for the selected swatch
        for (const key in dataset) {
          // Return if dataset is not model info or if model info is left empty
          if (!key.includes(pinKey) || !dataset[key]) {
            continue;
          }

          // Get the first model info as a default
          if (!modelInfo) {
            modelInfo = dataset[key];
          }

          // Get the size key from the dataset key
          const sizeKey = key.split(pinKey + anchorKey)[1].toLowerCase();

          // If the size key matches the current size, set the model info
          if (sizeKey && currentSize && sizeKey === currentSize) {
            modelInfo = dataset[key];
            break;
          }
        }

        // Update the model information on the product page
        if (productPageMetafieldBadge) {
          productPageMetafieldBadge.innerHTML = modelInfo ? modelInfo : productPageMetafieldBadge.dataset.default;
        }

        addModelInfoToFirstImage();
      });

      // Click the first selected swatch
      const input = swatch.querySelector('input');

      if (input.checked) {
        swatch.click();
      }
    })
  }


  // TODO: Update model information functions to update the HIDDEN (anchor) model information on the product page



  // TODO: Inject model information into the first image of the product page. When observe mutation, replace the first image with the model information.
  const productMediaWrapper = document.querySelector('.product-page .product__media__wrapper');

  if (productMediaWrapper) {
    const observer = new MutationObserver((mutationRecords) => {
      let isBadgeMutation = false;

      if (mutationRecords) {
        mutationRecords.forEach(record => {
          if (record.addedNodes) {
            record.addedNodes.forEach(node => {
              if (node.classList && node.classList.contains('metafield--badge')) {
                isBadgeMutation = true;
              }
            })
          }
        })
      }

      if (!isBadgeMutation) {
        addModelInfoToFirstImage();
      }
    });
    observer.observe(productMediaWrapper, {
      childList: true,
      subtree: true
    });
  }

  // TODO: On load, run the addToFirstImage function
  addModelInfoToFirstImage();

  // TODO: When a swatch is clicked, run the addToFirstImage function
  // TODO: Create a function to add model information to the first image, remove the current visible model information

  // Get the product page product container

  function addModelInfoToFirstImage() {
    // Find the hidden model info (truth of source)
    const productPageModelInfo = document.querySelector('.product-page .metafield--badge.anchor');
    const productImageGrid = document.querySelectorAll('.product-page .product__grid');

    // console.log("malik -- addModelInfoToFirstImage", productPageModelInfo, productImageGrid, productImageGridCount, productImageGrid.length);
    // console.log("malik -- addModelInfoToFirstImage");

    if (!productPageModelInfo || !productImageGrid || productImageGrid.length === 0) {
      return;
    }

    // Find the first image on the product page
    productImageGrid.forEach(grid => {
      const firstImage = grid.querySelector('.product__media');

      if (firstImage) {
        // Remove any visible model information
        const visibleModelInfo = firstImage.querySelector('.metafield--badge');

        if (visibleModelInfo) {
          visibleModelInfo.remove();
        }

        // Add the model information to the first image
        const modelInfo = productPageModelInfo.cloneNode(true);
        modelInfo.classList.remove('anchor');
        firstImage.appendChild(modelInfo);
      }
    })
  }

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener('theme:variant:change', function(event) {
    const compareAtPriceContainer = document.querySelector('.product-page .product__price__main .compare-at__price');

    var variant = event.detail.variant;
    var container = event.target;

    if (variant) {
      if (variant.compare_at_price > variant.price) {
        compareAtPriceContainer.innerHTML = '$' + (variant.compare_at_price * 0.01).toFixed(2);
      }

      else {
        compareAtPriceContainer.innerHTML = '';
      }

      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      const cartCounts = document.querySelectorAll('.dx--cart--count');

      cartCounts.forEach(count => {
        count.innerHTML = cart.item_count;
      });
    }
  });

  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
